import React from 'react';
import { Select, MenuItem, Box, Typography, SelectChangeEvent } from '@mui/material';
import { ColorVariante } from '../types';
import { resolveColor } from '../../../../catalogo/utils/colorResolver';

interface ColorDropdownProps {
  colores: ColorVariante[];
  value: string | null;
  onChange: (color: string, codigoColor: string | null) => void;
  disabled?: boolean;
}

export function ColorDropdown({ colores, value, onChange, disabled = false }: ColorDropdownProps) {
  const handleChange = (e: SelectChangeEvent<string>) => {
    const selectedColor = colores.find(c => c.color === e.target.value);
    if (selectedColor) {
      onChange(selectedColor.color, selectedColor.codigo_color);
    }
  };

  if (colores.length === 0) {
    return (
      <Typography sx={{ color: '#8E8994', fontSize: '16px' }}>
        Sin colores
      </Typography>
    );
  }

  return (
    <Select
      value={value ?? ''}
      onChange={handleChange}
      disabled={disabled}
      displayEmpty
      renderValue={(selected) => {
        if (!selected) {
          return <Typography sx={{ fontSize: '16px', color: '#A09AA5' }}>Elegir color</Typography>;
        }
        const c = colores.find(x => x.color === selected);
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Box
              sx={{
                width: 14,
                height: 14,
                borderRadius: '50%',
                backgroundColor: resolveColor({ nombre: c?.color ?? '', codigoColor: c?.codigo_color ?? null }),
                border: '1px solid rgba(0,0,0,0.15)',
                flexShrink: 0,
              }}
            />
            <Typography sx={{ fontSize: '16px', lineHeight: 1 }}>{selected}</Typography>
          </Box>
        );
      }}
      sx={{
        height: '56px',
        fontSize: '16px',
        borderRadius: '6px',
        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#DFDCE2' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#9B2B9D' },
        '& .MuiSelect-select': { py: 0, px: '14px', display: 'flex', alignItems: 'center' },
        width: '100%',
      }}
    >
      {colores.map((c) => (
        <MenuItem key={c.color} value={c.color}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Box
              sx={{
                width: 14,
                height: 14,
                borderRadius: '50%',
                backgroundColor: resolveColor({ nombre: c.color, codigoColor: c.codigo_color ?? null }),
                border: '1px solid rgba(0,0,0,0.15)',
                flexShrink: 0,
              }}
            />
            <Typography sx={{ fontSize: '16px' }}>{c.color}</Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
}
